/**
 * CRA release statuses (FAQ / Recital 37). Only 'release' (placed on market)
 * is Art.14-tracked. Testing releases (alpha/beta/rc) are permitted under
 * conditions — the DUTIES copy below is shown whenever an OEM picks one.
 */
export type ReleaseStatus = 'release' | 'rc' | 'beta' | 'alpha' | 'internal';

export const RELEASE_STATUS_OPTIONS: ReadonlyArray<{ value: ReleaseStatus; label: string }> = [
  { value: 'release', label: 'Release — placed on market' },
  { value: 'rc', label: 'Release candidate (testing)' },
  { value: 'beta', label: 'Beta (testing)' },
  { value: 'alpha', label: 'Alpha (testing)' },
  { value: 'internal', label: 'Internal build' },
];

export const isTesting = (s: ReleaseStatus | undefined): boolean => s === 'alpha' || s === 'beta' || s === 'rc';

/** Recital 37 manufacturer duties for testing releases — shown on selection. */
export const TESTING_DUTIES =
  'Testing release (CRA Recital 37): make it available only for the time needed to test and gather feedback; ' +
  'mark it with a visible sign that it does not comply with the Regulation; release it only after a risk assessment; ' +
  'meet the essential security requirements and vulnerability handling to the extent possible; ' +
  'and never force users to upgrade to a testing version. Only Release versions are tracked for Art.14.';

export function statusBadge(s: ReleaseStatus): { kind: 'teal' | 'med' | 'out'; text: string } {
  if (s === 'release') return { kind: 'teal', text: 'Release' };
  if (s === 'internal') return { kind: 'out', text: 'Internal · not tracked' };
  return { kind: 'med', text: `${s.toUpperCase()} · testing — not tracked` };
}
